import { get } from 'lodash';
import { put, select, takeEvery } from 'redux-saga/effects';
import { startAsyncValidation, stopAsyncValidation } from 'redux-form';
import { getFormValues } from 'redux-form';

import { SIGN_IN_FORM } from '../SignInForm';

import { createApiRequestSaga } from '../../../modules/api/saga';
import { ENDPOINTS } from '../../../modules/api/endpoints';
import { IAction } from '../../../interfaces/IAction';
import {
  authSetGlobalFormErrors,
  authSignIn,
  authSignInError,
  authSignInSuccess,
  authSubmitSignInForm,
} from '../actions';
import { getType } from 'typesafe-actions';
import { trackEvent } from '../../../utils/Analytics';

const signInSaga = createApiRequestSaga({
  actionSuccess: authSignInSuccess,
  actionError: authSignInError,
});

function* signInFormWatcher() {
  const data = yield select(getFormValues(SIGN_IN_FORM));

  yield put(
    authSignIn({
      url: ENDPOINTS.AUTH.SIGN_IN,
      method: 'post',
      data,
    }),
  );

  yield put(startAsyncValidation(SIGN_IN_FORM));
}

function* watchSignInResults(action: IAction) {
  const error = get(action, ['payload', 'errors', 'error'], 'unknown');

  if (!error) {
    trackEvent('Login', {});
  }

  yield put(
    authSetGlobalFormErrors({
      formName: SIGN_IN_FORM,
      errors: [error],
    }),
  );

  yield put(stopAsyncValidation(SIGN_IN_FORM, {}));
}

export default function* authSignInSaga() {
  yield takeEvery(getType(authSubmitSignInForm), signInFormWatcher);
  yield takeEvery([getType(authSignIn)], signInSaga);
  yield takeEvery([getType(authSignInSuccess), getType(authSignInError)], watchSignInResults);
}



// WEBPACK FOOTER //
// ./src/containers/Auth/saga/signInSaga.ts